export default __webpack_public_path__ + "static/media/patient_selected_full.5a188458.svg";